import * as nsVue from 'vue'

const tags = ['div', 'ul', 'li', 'a', 'span', 'i', 'button']

interface Hyper {
  h: CF;
  e: '';
  div: TagF; ul: TagF; li: TagF; a: TagF; span: TagF; i: TagF; button: TagF;
}

export default function hyper(c: nsVue.CreateElement): Hyper {
  let h = _hyper(c);
  let ret = {h} as Hyper
  ret.e = ''
  for (let tag of tags) {
    ret[tag] = (a, b) => h(tag, a, b)
  }
  return ret
}

type Attrs = {
  key?: string | number;
  class?: string;
  show?: boolean;
  [k: string]: any;
}

interface CF {
  (tag: string): nsVue.VNode;
  (tag: string, children: nsVue.VNodeChildren): nsVue.VNode;
  (tag: string, attrs?: Attrs, children?: nsVue.VNodeChildren): nsVue.VNode;
  (tag: nsVue.Component): nsVue.VNode;
  (tag: nsVue.Component, children: nsVue.VNodeChildren): nsVue.VNode;
  (tag: nsVue.Component, attrs?: Attrs, children?: nsVue.VNodeChildren): nsVue.VNode;
}

interface TagF {
  (): nsVue.VNode;
  (children: nsVue.VNodeChildren): nsVue.VNode;
  (attrs?: Attrs, children?: nsVue.VNodeChildren): nsVue.VNode;
}

function _hyper(c: nsVue.CreateElement): CF {
  function f(tag, a, b) {
    let attrs: Attrs | undefined
    let children: nsVue.VNodeChildren | undefined
    if (Array.isArray(a) || typeof a === 'number' || typeof a === 'string') {
      attrs = undefined
      children = a as nsVue.VNodeChildren
    }
    else {
      attrs = a
      children = b
    }
    return c(tag, attrs ? data(attrs) : undefined, children)
  }
  return f as CF
}

const c0 = '!'.charCodeAt(0)
const c1 = '$'.charCodeAt(0)

function data(attrs: Attrs): nsVue.VNodeData {
  let data: nsVue.VNodeData = {}
  for (let key in attrs) {
    let val = attrs[key]
    if (key === 'key')
      data.key = val
    else if (key === 'class')
      data.staticClass = val
    else if (key === 'style')
      data.staticStyle = val
    else if (key === 'show') {
      if (!data.directives)
        data.directives = []
      data.directives.push({name: 'show', value: val} as any)
    }
    else {
      let first = key.charCodeAt(0)
      if (first === c0) // !key
        data[key.substr(1)] = val
      else if (first === c1) {
        if (key.charCodeAt(1) === c1) { // $$nativeOn
          let name = key.substr(2)
          data.nativeOn ? (data.nativeOn[name] = val) : (data.nativeOn = {[name]: val})
        }
        else { // $on
          let name = key.substr(1)
          data.on ? (data.on[name] = val) : (data.on = {[name]: val})
        }
      }
      else if (key.charCodeAt(key.length - 1) === c1) {
        if (key.charCodeAt(key.length - 2) === c1) { // style$$
          let name = key.substr(0, key.length - 2)
          data.style ? (data.style[name] = val) : (data.style = {[name]: val})
        }
        else { // class$
          let name = key.substr(0, key.length - 1).replace('_', '-')
          data.class ? (data.class[name] = val) : (data.class = {[name]: val})
        }
      }
      else {
        data.attrs ? (data.attrs[key] = val) : (data.attrs = {[key]: val})
      }
    }
  }
  return data
}
